import React,{useState,useEffect} from 'react'
import { validateOnlyNumbers } from '../../../js/helpers/Utils/Validations';
import { Singleton } from '../../../js/Singleton';
import SelectComponent from './SelectComponent';
import { reprogramacion1,reprogramacion2,reprogramacion3,reprogramacion4,reprogramacion5 } from '../../../Images/Images';

const language= new Singleton();

const SelectReprogramPhone = ({setPhoneReprogram,numbers,phoneCall}) => {
    const [selectionReschedule,setSelectionReschedule] = useState(1);
    const [phone,setPhone] =useState("");
    const imagesNumber = { "1": reprogramacion1, "2": reprogramacion2, "3": reprogramacion3, "4": reprogramacion4, "5": reprogramacion5 };
    const [arrayNums, setArrayNums] = useState([{ img: reprogramacion1, number: phoneCall, id: 1 }]);
    const [ displayedComponent, setDisplayedComponent] = useState( -1);
    const [otherPhone, setOtherPhone]=useState("");


    useEffect(() => {
        getListOfPhones()
    }, [numbers])
    
    
    useEffect(() => {
        setPhoneReprogram({selectionReschedule:selectionReschedule, phone:phone,otherPhone:otherPhone});
    }, [phone,otherPhone])

    const getListOfPhones =()=>{
        if(numbers !== undefined)
        {
            if(Object.keys(numbers).length>0)
            {
                let arrayNums = Object.keys(numbers).map(i => numbers[i]);
                let b = [...arrayNums].map((item) => { 
                    return { img: imagesNumber[item.Graphic], number: item.Phone, id: item.Graphic } 
                });
                let c = b.filter(item=>{if(item.number!=="") {return item}})
                setArrayNums(c)
            }else{
                setArrayNums([{img:reprogramacion1,number:phoneCall,id:1},{img:reprogramacion1,number:phoneCall,id:1}])
            }
            
        }
        
    }
    
    return (
        <div>
            <div className="rescheduleSelector">
                <div className={"rescheduleRadioButton" + (selectionReschedule === 1 ? " active" : " inactive")} onClick={() => setSelectionReschedule(1)}></div>
                    <div className="containerReschedule">
                    <SelectComponent
                            bottomBox={60}
                            defaultDiv={{ item: "texSelection" }}
                            displayer={"bigDisplayer"}
                            customCell={"cellImageText"}
                            parameters={{ image: "img", text: "number" }}
                            dataSource={arrayNums}
                            closeOthers={true}
                            itemDefault={0}
                            displayedList={displayedComponent}
                            onDisplayList={(compSelected) => setDisplayedComponent(compSelected)}
                            onSelectItem={(itemSelected) => setPhone(itemSelected)} />
                    </div>
                </div>
                <div className="rescheduleSelector">
                <div className={"rescheduleRadioButton" + (selectionReschedule === 2 ? " active" : " inactive")} onClick={() => setSelectionReschedule(2)}></div>
                <input type="text"
                    placeholder={language.getText("GUISearchWindowphoneNum")}
                    disabled={selectionReschedule === 1}
                    className={"otherPhoneReschedule" + (selectionReschedule === 2 ? " active" : " inactive")}
                    value={otherPhone}
                    onChange={event => setOtherPhone(event.target.value)}
                    onKeyPress={validateOnlyNumbers} />
                </div>
        </div>
    )
}

export default SelectReprogramPhone


// WEBPACK FOOTER //
// ./src/components/workSpace/Others/SelectReprogramPhone.jsx